// extracted by mini-css-extract-plugin
export default {"title":"Home_title__ANWNn","globalCryptoStatsTitle":"Home_globalCryptoStatsTitle__8lvF0"};